import $ from 'jquery';

(function($) {
	$(document).ready(function() {

		$.fn.listingMap = function( options ) {

	        var defaults = {
	        	url : '/find-schools',
	        	defaultUrl : '/',
	        	noImageUrl : '/img/location_placeholder.jpg',
		        p: 1,
		        n : 12,
		        page : 'p',
		        nshow : 'n',
		        name : 'q',
		        pager_length : 4,
	        	locations: {},
	        	searchData: {
	        		zip: 0,
	        		lng: 29.92363800,
	        		lat: -95.55919000,
		            zips: {},
		            type: '',
		            language: {},
		            zoom: 13,
		            zipForget: 0,
	        	},
	            mapWrapper: 'show-map',
	            mapPart: '#map-part',
	            otherPart: '#other-part',
	            mobileFilters: '#mobile-filter-submenu',
	            listElement: '#list-locations-holder',
	            paginationHolder: '#pagination',
	            paginationWrapper: '#pagination-wrapper',
	            entriesWrapper: '#entries-wrapper',
	            filtersWrapper: '#location-filters-top',
	            schoolWrapper: '#school-part',
	            styledMapType: false,
	            loadedInsuranceBanner: false,
	            notClickedInsuranceBanner: true,
	            insuranceBannerHtml: '',
	            insuranceSubId: 'dschool_auto_v1',
	            scriptSrc: "https://d3iv2l0es6sf8g.cloudfront.net/1047/SDC/gl/auto/cfad_s.js",
	            today: 'Monday',
	            daysShort: {
			        'Monday' : 'Mon',
			        'Tuesday' : 'Tue',
			        'Wednesday' : 'Wed',
			        'Thursday' : 'Thu',
			        'Friday' : 'Fri',
			        'Saturday' : 'Sat',
			        'Sunday' : 'Sun'
			    },
			    hours:{}
	       };
           this.settings = $.extend({}, defaults, options);
		   	if (this.length > 1) {
	            this.each(function() { $(this).pluginName(options) });
	            return this;
	        }

	        if (typeof styledMapType === 'undefined' || !styledMapType)
    			var styledMapType = $.getStyledGoogleMap();

    		this.settings.styledMapType = styledMapType;
	        // private variables
	        var pagedData,geocoder,map,mapLoaded = false,extraFilter = false, markers = [],infoWindows = [],serviceAreas = [],loadNewLocations = true,locationZipFilter = null,dragMapFilter=null,loadNewLocationsFilter=null, loadedSchool = false,loadedLocation=false,shouldLoadNewLocations=true;
	        var iconimage = new google.maps.MarkerImage(this.settings.defaultUrl+'/img/svg/map-pointer.svg', null, null, null, new google.maps.Size(36,42));
	        var iconimageHover = new google.maps.MarkerImage(this.settings.defaultUrl+'/img/svg/map-pointer-hover.svg', null, null, null, new google.maps.Size(42,48));



	       // public methods
	       this.initialize = function() {
	            // do something ...

	            this.loadMap();
	            this.loadLocations();
	            // this.placeMarkers();

	            this.attachEvents();




	            return this;
	       };

	       this.attachEvents = function(){
	        	var that = this;



	        	window.onpopstate = function() {
				  	if(loadedSchool){
				  		$(that.settings.schoolWrapper).find('#school-holder-view').empty().removeClass('active');
				        $(that.settings.schoolWrapper).removeClass('active');

				        loadedSchool=false;
		        		return false;
				  	}
				}

				// window.onpushstate = function() {
				//   	if(loadedSchool){

				//   	}else{
				//   		window.location.reload(true);
				//   	}
				// }


	        	$(that.settings.filtersWrapper).find('.filter-menu-margin').on('show.bs.dropdown', function () {
	        		if(that.settings.searchData && that.settings.searchData.type){
	        			$(that.settings.filtersWrapper).find('#type-filter-unselect').removeClass('d-none')
	        		}else{
	        			$(that.settings.filtersWrapper).find('#type-filter-unselect').addClass('d-none')
	        		}

			if(that.settings.searchData && that.settings.searchData.language && Object.keys(that.settings.searchData.language).length > 0){
	        			$(that.settings.filtersWrapper).find('#language-filter-unselect').removeClass('d-none')
	        		}else{
	        			$(that.settings.filtersWrapper).find('#language-filter-unselect').addClass('d-none')
	        		}

			        $(that.settings.listElement).find('.partial-overlay').addClass('showed');
		        	$(that.settings.mapPart).find('.partial-overlay').addClass('showed');
			    }).on('hide.bs.dropdown', function () {
			        $(that.settings.listElement).find('.partial-overlay').removeClass('showed');
		        	$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');
			    });


	        	$(this.settings.mobileFilters).on('click','#location-view-button',function(){

	        		if($(this).hasClass('listingView')){

	        			$(that.settings.filtersWrapper).removeClass('active');
		        		$(that.settings.listElement).removeClass('active');
		        		$(that.settings.paginationHolder).removeClass('active');
		        		$(that.settings.otherPart).removeClass('active');
		        		$(that.settings.mobileFilters).find('#filter-view-button').removeClass('filtersView');
		        		$(this).removeClass('listingView').html('<i class="fas fa-landmark"></i>Locations List');


	        		}else{

		        		$(that.settings.filtersWrapper).removeClass('active');
		        		$(that.settings.listElement).addClass('active');
		        		$(that.settings.paginationHolder).addClass('active');
		        		$(that.settings.otherPart).addClass('active');
		        		$(that.settings.mobileFilters).find('#filter-view-button').removeClass('filtersView');
		        		$(this).addClass('listingView').html('<i class="fas fa-map-marked-alt"></i>Map View');
	        		}

	        		return false;

	        	});


	        	$(this.settings.mobileFilters).on('click','#filter-view-button',function(){

	        		if($(this).hasClass('filtersView')){

	        			$(that.settings.filtersWrapper).removeClass('active');

	        			if($(that.settings.mobileFilters).find('#location-view-button').hasClass('listingView')){
		        			// $(that.settings.otherPart).addClass('active');
		        			$(that.settings.otherPart).addClass('active');
		        			$(that.settings.listElement).addClass('active');
		        			$(that.settings.mapPart).removeClass('active');
		        			$(that.settings.listElement).find('.partial-overlay').removeClass('showed');
	        			}
	        			else{
		        			$(that.settings.otherPart).removeClass('active');
		        			$(that.settings.listElement).removeClass('active');
		        			$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');
	        			}


		        		$(this).removeClass('filtersView');

	        		}else{

		        		$(that.settings.filtersWrapper).addClass('active');
	        			if($(that.settings.mobileFilters).find('#location-view-button').hasClass('listingView')){
		        			// $(that.settings.otherPart).addClass('active');
		        			$(that.settings.listElement).addClass('active');
		        			$(that.settings.mapPart).removeClass('active');
		        			$(that.settings.listElement).find('.partial-overlay').addClass('showed');
	        			}
	        			else{
		        			$(that.settings.otherPart).addClass('active');
		        			$(that.settings.listElement).removeClass('active');
		        			$(that.settings.mapPart).find('.partial-overlay').addClass('showed');
	        			}




		        		$(this).addClass('filtersView');
	        		}

	        		return false;

	        	});


	        	$(this.settings.paginationWrapper).on('click','a.page-link',function(e){
	        		e.preventDefault();
	        		that.settings.p = $(this).data('page');

	        		that.buildLocationView();

	        	});

	        	$(this.settings.filtersWrapper).on('click','#search-location-list a.zipListItem',function(){


	        		var zipVal = $(this).data('zip'),
	        			name = $(this).data('city'),
	        			zipLat = $(this).data('lat'),
	        			zipLng = $(this).data('lng');

	        		var zipIcon = $(that.settings.filtersWrapper).find('#zip-remover');
	        		var inputSearchedText = $(that.settings.filtersWrapper).find('#location-zip-filter').val();
	        		var locationText = $(this).data('text');



			        if(zipVal && name){

						var encodedSearch = encodeURI(inputSearchedText+' ['+locationText+']');
			            gtag("event", "page_view", {
			              page_location: "https://www.driving-schools.com/search?q="+encodedSearch,
			              page_path: "/search?q="+encodedSearch,
			              page_title: "Search By Location"
			            });


			        	$('#search-location-list').find('input#location-zip-filter-hidden').val(zipVal);
			            $('#search-location-list').find('input#location-zip-lng-hidden').val(zipLng);
			            $('#search-location-list').find('input#location-zip-lat-hidden').val(zipLat);
			            $('#search-location-list').find('input#location-zip-city-hidden').val(name);
			            $('#search-location-list').find('input#location-zip-filter').val(locationText);
			            $('#location-zip-content').empty();
			            $(that.settings.listElement).find('.partial-overlay').removeClass('showed');
		        		$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');
		        		$(that.settings.filtersWrapper).removeClass('active');
		        		$(that.settings.mobileFilters).find('#filter-view-button').removeClass('filtersView');

		        		if(zipIcon)
			            	$(zipIcon).html('<i class="fas fa-times"></i>');

			            extraFilter = true;

			        	that.settings.searchData.zip = zipVal;
			        	that.settings.searchData.lat = zipLat;
			        	that.settings.searchData.lng = zipLng;
			        	that.settings.searchData.zips = {};

			        	that.settings.searchData.type = '';
		        		var inputsType = $(that.settings.filtersWrapper).find('input[name="type"]');
		        		$.each(inputsType,function(i,k){
		        			if($(k).prop('checked'))
		        				that.settings.searchData.type = $(k).val();

		        		});

		        		that.settings.searchData.language = {};
		        		var inputsType = $(that.settings.filtersWrapper).find('input[name="language[]"]');
		        		$.each(inputsType,function(i,k){
		        			if($(k).prop('checked'))
		        				that.settings.searchData.language[i] = $(k).val();

		        		});


		        		$.ajax({
					          method: "get",
					          url: '/zip/'+zipVal,
					          success: function(data) {
					          	
					          		if(data && data.zcta && data.zcta.json_center && data.zcta.json_center.geometry.coordinates){
					          			zipLng = data.zcta.json_center.geometry.coordinates[0];
					          			zipLat = data.zcta.json_center.geometry.coordinates[1];

					          			$('#search-location-list').find('input#location-zip-lng-hidden').val(zipLng);
			            				$('#search-location-list').find('input#location-zip-lat-hidden').val(zipLat);

									    setTimeout(function () {
							            	map.setCenter({lat:parseFloat(zipLat),lng: parseFloat(zipLng)});

							            }, 400);

					          		}else{
					          			$(that.settings.schoolWrapper).find('#school-holder-view').empty().removeClass('active');
					          			$(that.settings.schoolWrapper).removeClass('active');
					          			$.append_notification('error', 'Could not load selected Location. Please refresh the page and try again.');
					          			loadedSchool=false;
					          			loadedLocation=false;
					          		}


					          },
					          error: function(data) {
					                $.removeOverlay();
					                loadedSchool=false;
					                loadedLocation=false;
					                // window.location.reload(true);
					        }
					    });




		        		var langChosen = Object.keys(that.settings.searchData.language).length;

		        		if(langChosen){
		        			$(that.settings.filtersWrapper).find('#languageChoose i').text('( '+langChosen+' )');
		        		}else{
		        			$(that.settings.filtersWrapper).find('#languageChoose i').text(' ');
		        		}

		        		var typesChosen = (that.settings.searchData.type)? 1 : false;

		        		if(typesChosen){
		        			if(that.settings.searchData.type == 'carLicence'){
	  							$(that.settings.filtersWrapper).find('#classesType').text('Car');
		        			}

	  						if(that.settings.searchData.type == 'motorcycleLicence'){
	  							$(that.settings.filtersWrapper).find('#classesType').text('Motorcycle');
	  						}

	  						if(that.settings.searchData.type == 'commercialLicence'){
	  							$(that.settings.filtersWrapper).find('#classesType').text('CDL');
	  						}

		        		}else{
		        			$(that.settings.filtersWrapper).find('#classesType').text('Type of classes');
		        		}


			        }else{
			        	$(that.settings.schoolWrapper).find('#school-holder-view').empty().removeClass('active');
	          			$(that.settings.schoolWrapper).removeClass('active');
	          			$.append_notification('error', 'Could not load selected Location. Please refresh the page and try again.');
	          			loadedSchool=false;
	          			loadedLocation=false;
			        }

	        	});

	        	$(this.settings.filtersWrapper).on('keyup','input#location-zip-filter' ,function(e){
			        e.preventDefault();

			        var value = $(this).val();
			        var zipIcon = $(this).closest('div').find('#zip-remover');
			        if(e.keyCode === 13){
			        	if($(that.settings.filtersWrapper).find('#search-location-list a.zipListItem').length > 0){
			        		$(that.settings.filtersWrapper).find('#search-location-list a.zipListItem').first().trigger('click');
			        	}
				    }else{
				        if(value){
				        	$(that.settings.listElement).find('.partial-overlay').addClass('showed');
			        		$(that.settings.mapPart).find('.partial-overlay').addClass('showed');


				            clearTimeout(locationZipFilter);

				            if(zipIcon)
				            	$(zipIcon).html('<i class="fas fa-times"></i>')

				            if( value.length < 3 ){
				              $('#location-zip-content').empty();

				              return;
				            }

				            if(value.length < 5  && !isNaN(value))
				            	 return;


				            locationZipFilter = setTimeout(function () {
				                $.filter_zipLocation_search(value,'#location-zip-content');

				            }, 100);
				        }else{
				        	if(zipIcon)
				            	$(zipIcon).html('<i class="fas fa-search"></i>')

				        	$('#search-location-list').find('input#location-zip-filter-hidden').val('');
				            $('#search-location-list').find('input#location-zip-lng-hidden').val('');
				            $('#search-location-list').find('input#location-zip-lat-hidden').val('');
				            $('#search-location-list').find('input#location-zip-city-hidden').val('');
				            $('#search-location-list').find('input#location-zip-filter').val('');
				            $('#location-zip-content').empty();

				            $(that.settings.listElement).find('.partial-overlay').removeClass('showed');
			        		$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');

				            extraFilter = false;

				        	that.settings.searchData.zip = 0;
				        	that.loadLocations();


				        }
			        }

			    }).on('focus','input#location-zip-filter' ,function(e){
			        e.preventDefault();

			        var value = $(this).val();
			        if(value){
			            if( value.length > 2 ){
			                clearTimeout(locationZipFilter);
			                $(that.settings.listElement).find('.partial-overlay').addClass('showed');
		        			$(that.settings.mapPart).find('.partial-overlay').addClass('showed');
			                locationZipFilter = setTimeout(function () {
			                    $.filter_zipLocation_search(value,'#location-zip-content');

			                }, 100);

			            }
			        }

			    }).on('focusout','input#location-zip-filter' ,function(e){
			        e.preventDefault();

			        clearTimeout(locationZipFilter);
	                	locationZipFilter = setTimeout(function () {
	                    $(that.settings.listElement).find('.partial-overlay').removeClass('showed');
		        		$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');
	                    // $.filter_zipLocation_search(value,'#location-zip-content')
	                }, 1200);

			    });

	        	$(this.settings.filtersWrapper).on('click','#type-filter,#language-filter',function(e){
	        		e.preventDefault();
		        		extraFilter = true;
		        		that.settings.searchData.type = '';
		        		var inputsType = $(that.settings.filtersWrapper).find('input[name="type"]');
		        		$.each(inputsType,function(i,k){
		        			if($(k).prop('checked'))
		        				that.settings.searchData.type = $(k).val();

		        		});

		        		that.settings.searchData.language = {};
		        		var inputsType = $(that.settings.filtersWrapper).find('input[name="language[]"]');
		        		$.each(inputsType,function(i,k){
		        			if($(k).prop('checked'))
		        				that.settings.searchData.language[i] = $(k).val();

		        		});

		        		$(that.settings.listElement).find('.partial-overlay').removeClass('showed');
		        		$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');
		        		$(that.settings.filtersWrapper).removeClass('active');
		        		$(that.settings.mobileFilters).find('#filter-view-button').removeClass('filtersView');

		        		that.loadLocations();
		        		var langChosen = Object.keys(that.settings.searchData.language).length;

		        		if(langChosen){
		        			$(that.settings.filtersWrapper).find('#languageChoose i').text('( '+langChosen+' )');
		        		}else{
		        			$(that.settings.filtersWrapper).find('#languageChoose i').text(' ');
		        		}

		        		var typesChosen = (that.settings.searchData.type)? 1 : false;

		        		if(typesChosen){
		        			if(that.settings.searchData.type == 'carLicence'){
	  							$(that.settings.filtersWrapper).find('#classesType').text('Car');
		        			}

	  						if(that.settings.searchData.type == 'motorcycleLicence'){
	  							$(that.settings.filtersWrapper).find('#classesType').text('Motorcycle');
	  						}

	  						if(that.settings.searchData.type == 'commercialLicence'){
	  							$(that.settings.filtersWrapper).find('#classesType').text('CDL');
	  						}

		        		}else{
		        			$(that.settings.filtersWrapper).find('#classesType').text('Type of classes');
		        		}

	        	});

	        	// Unselect all radio buttons
	        	$(this.settings.filtersWrapper).on('click','#zip-remover',function(e){
	        		e.preventDefault();
		        	extraFilter = true;
		        	$('#search-location-list').find('input#location-zip-filter').val('');
		        	$('#search-location-list').find('input#location-zip-filter-hidden').val('');
		            $('#search-location-list').find('input#location-zip-lng-hidden').val('');
		            $('#search-location-list').find('input#location-zip-lat-hidden').val('');
		            $('#search-location-list').find('input#location-zip-city-hidden').val('');
		            $('#search-location-list').find('input#location-zip-filter').val('');
		            $('#location-zip-content').empty();

			        $(this).html('<i class="fas fa-search"></i>');


		        	$(that.settings.filtersWrapper).removeClass('active');
		        	$(that.settings.mobileFilters).find('#filter-view-button').removeClass('filtersView');
			        $(that.settings.listElement).find('.partial-overlay').removeClass('showed');
		        	$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');

		        	that.settings.searchData.zip = 0;
		        	that.settings.searchData.zipForget = 1;
		        	that.loadLocations();

	        	});

	        	// Unselect all radio buttons
	        	$(this.settings.filtersWrapper).on('click','#type-filter-unselect',function(e){
	        		e.preventDefault();
		        	extraFilter = true;
		        	that.settings.searchData.type = '';
	        		var inputsType = $(that.settings.filtersWrapper).find('input[name="type"]');
	        		$.each(inputsType,function(i,k){
	        			$(k).prop('checked',false)
	        		});

	        		that.loadLocations();

	        		$(that.settings.listElement).find('.partial-overlay').removeClass('showed');
		        	$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');
		        	$(that.settings.filtersWrapper).removeClass('active');
		        	$(that.settings.mobileFilters).find('#filter-view-button').removeClass('filtersView');

	        		var typesChosen = (that.settings.searchData.type)? 1 : false;

	        		if(typesChosen){
	        			if(that.settings.searchData.type == 'carLicence'){
  							$(that.settings.filtersWrapper).find('#classesType').text('Car');
	        			}

  						if(that.settings.searchData.type == 'motorcycleLicence'){
  							$(that.settings.filtersWrapper).find('#classesType').text('Motorcycle');
  						}

  						if(that.settings.searchData.type == 'commercialLicence'){
  							$(that.settings.filtersWrapper).find('#classesType').text('CDL');
  						}

	        		}else{
	        			$(that.settings.filtersWrapper).find('#classesType').text('Type of classes');
	        		}
	        	});

	        	$(this.settings.filtersWrapper).on('click','#language-filter-unselect',function(e){
	        		e.preventDefault();
		        	extraFilter = true;
		        	that.settings.searchData.language = {};
	        		var inputsType = $(that.settings.filtersWrapper).find('input[name="language[]"]');
	        		$.each(inputsType,function(i,k){
	        			$(k).prop('checked',false);
	        		});

	        		that.loadLocations();
	        		$(that.settings.listElement).find('.partial-overlay').removeClass('showed');
		        	$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');
		        	$(that.settings.filtersWrapper).removeClass('active');
		        	$(that.settings.mobileFilters).find('#filter-view-button').removeClass('filtersView');

	        		var langChosen = Object.keys(that.settings.searchData.language).length;

	        		if(langChosen){
	        			$(that.settings.filtersWrapper).find('#languageChoose i').text('( '+langChosen+' )');
	        		}else{
	        			$(that.settings.filtersWrapper).find('#languageChoose i').text(' ');
	        		}
	        	});

	        	$(this.settings.listElement).on( 'click','.view-location-popup', function(e) {
	        		e.preventDefault();
	        		var dataHref = $(this).attr('href'),
	        			dataSchool = $(this).data('school'),
	        			dataLocation = $(this).data('location');

	        		if(dataHref){
	        			$(this).trigger('focusout');
	        			that.loadSchool(dataHref,dataSchool,dataLocation);
	        		}
	        		return false;
				})

				$(this.settings.mapPart).on( 'click','.view-location-popup', function(e) {
	        		e.preventDefault();
	        		var dataHref = $(this).attr('href'),
	        			dataSchool = $(this).data('school'),
	        			dataLocation = $(this).data('location');

	        		if(dataHref){
	        			$(this).trigger('focusout');
	        			that.loadSchool(dataHref,dataSchool,dataLocation);
	        		}
	        		return false;
				})


				// Change to Map view on Loaded School
				$(this.settings.schoolWrapper).on( 'shown.bs.tab','#locations-map-view-tab', function(e) {
					if(loadedSchool)
						that.buildSmallMapSchool();
				})


	        	// Close School Page
				$(this.settings.schoolWrapper).on( 'click','a#go-back', function(e) {

	        		// e.preventDefault();
	        		$(that.settings.schoolWrapper).find('#school-holder-view').empty().removeClass('active');
			        $(that.settings.schoolWrapper).removeClass('active');
			        if (history.pushState) {
			        	var prevHref = 	that.settings.url;
					    window.history.pushState({path:prevHref},'',prevHref);
					}
			        loadedSchool=false;
	        		return false;
				})


	        	$(this.settings.listElement).on( 'mouseenter','.dsl-info-holder', function() {
	        		var markerId = $(this).data('id');
	        		if(markers[markerId]){
	        			var selectedLocation = $.multiArrayReturn(that.settings.locations,'id',markerId);
                        shouldLoadNewLocations = false;
                        if(selectedLocation){          

                        	markers[markerId].setIcon(that.settings.defaultUrl+'/uploads/images/marker-'+selectedLocation.currentOrderNo+'-hover.png');
                        	markers[markerId].setZIndex(99999);
                        	$(this).find('.ds-image img').attr('src',that.settings.defaultUrl+'/uploads/images/marker-'+selectedLocation.currentOrderNo+'-hover.png');
                        }
                        // map.setCenter(markers[markerId].getPosition());
                        // map.panTo(markers[markerId].getPosition());
                    }

				})
				.on( 'mouseleave','.dsl-info-holder', function() {
					var markerId = $(this).data('id');
					if(markers[markerId]){
						var selectedLocation = $.multiArrayReturn(that.settings.locations,'id',markerId);
                        shouldLoadNewLocations = true;
                        if(selectedLocation){
	                        markers[markerId].setIcon(that.settings.defaultUrl+'/uploads/images/marker-'+selectedLocation.currentOrderNo+'.png');
	                        markers[markerId].setZIndex(markerId);
	                        $(this).find('.ds-image img').attr('src',that.settings.defaultUrl+'/uploads/images/marker-'+selectedLocation.currentOrderNo+'.png');
	                    }
                    }

				});




				$(this.settings.listElement).on( 'change','#insurance-banner-question input', function(e) {
    				var linkToRedirect = $(that.settings.listElement).find('#'+that.settings.insuranceSubId+' a');

	                if($(linkToRedirect).length){
	                	if($(this).val() == 'yes'){
							$('#insurance-banner-question').find('#insurance-yes').addClass('chosen-yes')
							that.settings.notClickedInsuranceBanner = false;
						}else{
							var linkText = $(linkToRedirect).attr('href');
							window.open(linkText, '_blank');

							that.settings.notClickedInsuranceBanner = false;
							$('#locations-insurance-holder').removeClass('auto-insurance-banner-loaded');
						}


	                }
	        		return false;
				})

				$(this.settings.listElement).on( 'click','#insurance-compare-link', function(e) {
    				that.settings.notClickedInsuranceBanner = false;
				})


	       };

	       this.buildSmallMapSchool = function(){

	       		var that = this;
	       		if(loadedSchool && loadedLocation){
	       			var schoolLocations = $.multiArrayReturn(that.settings.locations,'schoolsId',loadedSchool,true);
	        		var selectedLocation = $.multiArrayReturn(that.settings.locations,'id',loadedLocation);
	        		if(schoolLocations && selectedLocation){

	        			var smallMapHolder = $(this.settings.schoolWrapper).find('#school-map-fixed');


				var smallMap = new google.maps.Map(smallMapHolder[0], {
				                zoom: 13,
				                center: {lat: parseFloat(selectedLocation.latitude), lng: parseFloat(selectedLocation.longitude)},
				                streetViewControl: false,
				                fullscreenControl:false,
				                mapTypeControl: false,
				                mapTypeControlOptions: {
				                  mapTypeIds: ['styled_map']
				                }
				              });

				              smallMap.mapTypes.set('styled_map', that.settings.styledMapType);
				              smallMap.setMapTypeId('styled_map');


				             $.each(schoolLocations,function(i,k){
				             	var contentString = that.infoWindowString(k,true);

					            var markerSmall = new google.maps.Marker({
								            position: {lat:parseFloat(k.latitude),lng: parseFloat(k.longitude)},
								            label: '',
								            icon: (selectedLocation.id && selectedLocation.id == k.id) ? iconimageHover : iconimage,
								            draggable:false,
								            map: smallMap,
								            animation: google.maps.Animation.DROP,
								          });


					            	var infowindow = new google.maps.InfoWindow({
												      content: contentString,
												      maxWidth: 320
												    });

					            		infoWindows.push(infowindow);

						                markerSmall.addListener('click', function() {
						                     infowindow.open(map, markerSmall);
						                });

										if(selectedLocation.id && selectedLocation.id == k.id){
						                    markerSmall.setIcon(iconimageHover);					                      	
					                      	infowindow.open(map, markerSmall);
						                }


				             })

	        		}
	       		}
	       }

	       this.loadSchool = function(href,schoolId = false, locationId = false){

	        	var that = this;
	        	if(!$(that.settings.schoolWrapper).hasClass('active'))
	        		$(that.settings.schoolWrapper).addClass('active');



	        	$.ajax({
			          method: "post",
			          url: href,
			          success: function(data) {
			          		if(data){
			          			$(that.settings.schoolWrapper).find('#school-holder-view').addClass('active').empty().html(data).promise().done(function(){

			          			   $(that.settings.schoolWrapper).trigger('focus');
								   $.smoothScroll(that.settings.schoolWrapper+' #school-holder-view');
								   $.initColorBox(that.settings.schoolWrapper+' .schoolSlider','schoolSlider');

								   loadedSchool = schoolId;
								   loadedLocation = locationId;

								   $.initLoadEmailsSchool(that.settings.schoolWrapper+' #load-emails-click');
								   $.initNavigateClick(that.settings.schoolWrapper+' #location-map');
								   $.programReadMoreClick(that.settings.schoolWrapper+' #school-programs-holder');
								   $.initReviewForm();

								   	if (history.pushState) {
									    window.history.pushState({path:href},'',href);
									}
									if ($(that.settings.schoolWrapper).is(":focus")) {
							            // return false;
							        } else {
							            $(that.settings.schoolWrapper).attr('tabindex','-1');
							            $(that.settings.schoolWrapper).focus();
							        };

							        that.jSwitchCall();


								});


			          		}else{
			          			$(that.settings.schoolWrapper).find('#school-holder-view').empty().removeClass('active');
			          			$(that.settings.schoolWrapper).removeClass('active');
			          			$.append_notification('error', 'Could not load selected Location. Please refresh the page and try again.');
			          			loadedSchool=false;
			          			loadedLocation=false;
			          		}


			          },
			          error: function(data) {
			                $.removeOverlay();
			                loadedSchool=false;
			                loadedLocation=false;
			                // window.location.reload(true);
			        }
			    });

	       };

	       this.loadMap = function(){

	        	var that = this;
	        	geocoder = new google.maps.Geocoder();

	        	map = new google.maps.Map(document.getElementById(this.settings.mapWrapper), {
		              zoom: that.settings.searchData.zoom,
		              center: {lat: parseFloat(that.settings.searchData.lat), lng: parseFloat(that.settings.searchData.lng)},
		              streetViewControl: false,
		              fullscreenControl:false,
		              mapTypeControl: false,
		              zoomControl: true,
					  zoomControlOptions: {
					  	position: google.maps.ControlPosition.RIGHT_TOP
					  },
                      minZoom : 6,
                      maxZoom : 17,
		              mapTypeControlOptions: {
		                mapTypeIds: ['styled_map']
		              }
		            });

		            mapLoaded = true;
		            // map.setCenter(results[0].geometry.location);
		            map.mapTypes.set('styled_map', this.settings.styledMapType);
		            map.setMapTypeId('styled_map');

		            // google.maps.event.addListener(map, 'dragend', function() { alert('map dragged'); } );
		            map.addListener('zoom_changed', function() {
		              that.settings.searchData.zoom = map.getZoom();
		              return false;
			       });

		            var dragClicks = 1;
		            // Handle Small Drags , not to call on small drag , but also not to forget to update list
		            google.maps.event.addListener(map,'idle',function(){

				      if(!this.get('dragging') && this.get('oldCenter') && this.get('oldCenter')!==this.getCenter() && shouldLoadNewLocations) {

				        //do what you want to
				        var distance = (google.maps.geometry.spherical.computeDistanceBetween(this.get('oldCenter'), this.getCenter()) / 1000).toFixed(2);

				        if(distance > 3 || dragClicks > 3){
					        that.settings.searchData.lat = this.getCenter().lat();
					        that.settings.searchData.lng = this.getCenter().lng();
					        dragClicks=1;

					        if(loadNewLocations)
				                that.loadLocations();


				        }

				      }
				      if(!this.get('dragging')){

				       this.set('oldCenter',this.getCenter())
				      }

				    });

				    google.maps.event.addListener(map,'dragstart',function(){

				      this.set('dragging',true);
				      that.settings.searchData.zip = 0;

				    });

				    google.maps.event.addListener(map,'dragend',function(){
				      dragClicks++;
				      this.set('dragging',false);
				      google.maps.event.trigger(this,'idle',{});
				    });

	       };

	       this.loadLocations = function(){

	        	var that = this;
	        	if(extraFilter){
	        		that.settings.p = 1;
	        		that.clearMarkers();
	        		// that.closeServiceAreas();
	        	}

        		if(loadNewLocations){
	        		$(that.settings.filtersWrapper).find('.partial-overlay').addClass('showed');
	        		$(that.settings.mobileFilters).find('.partial-overlay').addClass('showed');
	        		$(that.settings.listElement).addClass('loading');
	        		$(that.settings.mapPart).addClass('loading');
	        		loadNewLocations = false;
	        		// that.closeServiceAreas();

	        		// $(that.settings.mapPart).find('.partial-overlay').addClass('showed');
		        	$.ajax({
		        		  async: true,
				          method: "post",
				          url: "/locations/list",
				          // dataType: "jsonp",
				          // contentType: "application/json; charset=utf-8",
				          data: that.settings.searchData,
				          success: function(data) {

				          		if(data.locations){
					          		if(data.locations.length <= that.settings.p*that.settings.n)
					          			that.settings.p = 1;

					          		if(data.locations.length <= 2){
					          			that.clearMarkers();
		        						// that.closeServiceAreas();
					          		}

				          			// that.settings.locations = data.locations.sort((a, b) => (a.currentOrderCalculated < b.currentOrderCalculated) ? 1 : -1);
				          			that.settings.locations = data.locations;
				          		}

				          		if(data.searchData)
				          			that.settings.searchData = data.searchData;

				         		setTimeout(function () {
					          		that.buildLocationView();
					          		that.filterMarkers();
                                    that.closeServiceAreas();
                                    that.closeInfoWindows();
					          		extraFilter = false;

					          		$(that.settings.filtersWrapper).find('.partial-overlay').removeClass('showed');
					          		$(that.settings.mobileFilters).find('.partial-overlay').removeClass('showed');
					          		$(that.settings.listElement).removeClass('loading');
					          		$(that.settings.mapPart).removeClass('loading');

					          		if($(window).width() < 991){
						          		if($(that.settings.mobileFilters).find('#location-view-button').hasClass('listingView')){
						        			$(that.settings.otherPart).addClass('active');
						        			$(that.settings.listElement).addClass('active');
						        			$(that.settings.mapPart).removeClass('active');
						        			$(that.settings.listElement).find('.partial-overlay').removeClass('showed');
					        			}
					        			else{
						        			$(that.settings.otherPart).removeClass('active');
						        			$(that.settings.listElement).removeClass('active');
						        			$(that.settings.mapPart).addClass('active');
						        			$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');
					        			}
				        			}

					          		loadNewLocations = true;
					            }, 600);


				          },
				          error: function(data) {
				                $(that.settings.filtersWrapper).find('.partial-overlay').removeClass('showed');
				                $(that.settings.mobileFilters).find('.partial-overlay').removeClass('showed');
				                $(that.settings.listElement).removeClass('loading');
				                $(that.settings.listElement).removeClass('mapPart');
				                loadNewLocations = true;

				                if($(window).width() < 991){
					                if($(that.settings.mobileFilters).find('#location-view-button').hasClass('listingView')){

					        			$(that.settings.otherPart).addClass('active');
					        			$(that.settings.listElement).addClass('active');
					        			$(that.settings.mapPart).removeClass('active');
					        			$(that.settings.listElement).find('.partial-overlay').removeClass('showed');
				        			}
				        			else{
					        			$(that.settings.otherPart).removeClass('active');
					        			$(that.settings.listElement).removeClass('active');
					        			$(that.settings.mapPart).addClass('active');
					        			$(that.settings.mapPart).find('.partial-overlay').removeClass('showed');
				        			}
			        			}
				                // $(that.settings.mapPart).find('.partial-overlay').removeClass('showed');
				                // window.location.reload(true);
				        }
				    });

			    }else{
			    	clearTimeout(loadNewLocationsFilter);

			    	setTimeout(function () {
			    		$(that.settings.filtersWrapper).find('.partial-overlay').removeClass('showed');
			    		$(that.settings.mobileFilters).find('.partial-overlay').removeClass('showed');
			    		if(!loadNewLocations){
			    			loadNewLocationsFilter = setTimeout(function () {
			    				// Timeout Fix to let user search again after 1 second. Prevent users to scroll map too fast and make milions of requests
			    				if(!loadNewLocations)
			    					loadNewLocations = true;

			    			}, 1600);
			    		}

					}, 600);
			    }

	       };

           this.filterMarkers = function() {

                var that = this;
                $.each (markers,function(i,k){
                    if(markers[i] && markers[i]){
                        var locationIds = $.multiArrayReturn(that.settings.locations,'id',i,true);
                        if(!locationIds.length){
                            markers[i].setMap(null);
                            delete markers[i];
                        }
                    }

                });

                
                that.placeMarkers();
           };
	       this.placeMarkers = function() {
	       		var that = this;
	       		that.clearMarkers();
	            $.each(that.settings.locations,function(i,k){
	            	that.addMarker({lat:parseFloat(k.latitude),lng: parseFloat(k.longitude)},k);
	            });
	       };

	       this.clearMarkers = function() {
			      $.each (markers,function(i,k){
			      	if(markers[i] && markers[i]){
				    	markers[i].setMap(null);
				    	delete markers[i];
			    	}
			      });
	       };

	       this.closeInfoWindows = function() {
			    for (var i=0;i<infoWindows.length;i++) {
				     infoWindows[i].close();
				}

				return true;
	       };

	       this.closeServiceAreas = function() {
               map.data.forEach(function(feature) {
                   if (serviceAreas.includes(feature.getProperty("Id"))) {
                       map.data.remove(feature)
                   }
               });
				serviceAreas = [];
				return true;
	       };

	       this.ddToDms = function(lat, lng) {
				   var lat = lat;
				   var lng = lng;
				   var latResult, lngResult, dmsResult;

				   lat = parseFloat(lat);
				   lng = parseFloat(lng);

				   latResult = (lat >= 0)? ' ' : '-';

				   // Call to getDms(lat) function for the coordinates of Latitude in DMS.
				   // The result is stored in latResult variable.
				   latResult += this.getDms(lat);

				   lngResult = (lng >= 0)? ' ' : '-';

				   // Call to getDms(lng) function for the coordinates of Longitude in DMS.
				   // The result is stored in lngResult variable.
				   lngResult += this.getDms(lng);

				   // Joining both variables and separate them with a space.
				   // dmsResult = latResult + ' ' + lngResult;
				   dmsResult = {
				        'lat' : latResult,
				        'lng' : lngResult
				   }

				   // Return the resultant string
				   return dmsResult;
		   }
		   this.getDms = function(val) {

			  var valDeg, valMin, valSec, result;

			  val = Math.abs(val);

			  valDeg = Math.floor(val);
			  result = valDeg + "º";

			  valMin = Math.floor((val - valDeg) * 60);
			  result += valMin + "'";

			  valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000;
			  // result += valSec + '"';
			  result += parseInt(valSec) + '"';

			  return result;
		   }

		   this.infoWindowString = function(location,schoolViewOpen){

		   		if(schoolViewOpen){
					  if(location.image){
			            var image = this.settings.defaultUrl+'/'+location.image;
			            var explodeFilename = location.image.split('.');
	        			 	if (typeof explodeFilename[0]!=='undefined')
	        			 		var imageFileName = this.settings.defaultUrl+'/'+explodeFilename[0]+'.webp';

					  }
			          else if(location.schoolImage){
			            var image = this.settings.defaultUrl+'/uploads/images/schools/'+location.schoolImage;
			            var explodeFilename = location.schoolImage.split('.');
	        			 	if (typeof explodeFilename[0]!=='undefined')
	        			 		var imageFileName = this.settings.defaultUrl+'/uploads/images/schools/'+explodeFilename[0]+'.webp';

			          }
			          else{
			            var image = this.settings.defaultUrl+'/img/noimage.jpg';
			            var imageFileName = this.settings.defaultUrl+'/img/noimage.webp';
			          }

			          var locationLink = '/school/'+location.schoolSlug+'/location/'+location.id,
			              loaderIcon = this.settings.defaultUrl+'/img/loader.svg',
			              avg = (!location.reviewsAVG)? '4.8' : parseFloat(location.reviewsAVG);


			          var contentString = '<div class="info-window-content">'+
			                                  '<div class="info-window-box">'+
			                                      '<div class="info-window-text">'+
			                                        '<div class="image-view">'+
			                                          '<div class="info-window-image-holder">';
				            contentString += '				<picture>';
															if(imageFileName){
							contentString += '				<source srcset="'+imageFileName+'" type="image/webp">';
															}
							contentString += '				<img class="lazyload info-window-image" alt="'+location.name+'" data-src="'+image+'" loading="lazy" width="80" height="45">';
							contentString += '				</picture>'+
			                                          '</div>'+
			                                          '<div class="info-window-name">'+
			                                            '<label class="location-label"><i class="fas fa-map-marker-alt"></i>'+location.displayAddress+'</label>'+
			                                          '</div>'+
			                                        '</div>'+
			                                        '<div class="contact-view">'+
			                                            '<div class="info-window-flex">';
			                                            if(location.phoneOne){
			                                               contentString += '<div class="contact-block">'+
			                                                                    '<label>Contact Phone</label>'+
			                                                                    '<a href="tel:'+location.phoneOne.replace(/[^0-9]/g, "")+'">'+
			                                                                      '<i class="fas fa-phone-alt"></i>'+location.phoneOne+
			                                                                    '</a>'+
			                                                                '</div>';
			                                            }

			                                            if(location.longitude && location.latitude){
			                                               contentString += '<div class="contact-block">'+
			                                                                    '<label>Direction</label>'+
			                                                                    '<a href="http://maps.google.com?daddr='+location.latitude+','+location.longitude+'&amp;ll=" class="getDirectionClick" data-lat="'+location.latitude+'" data-lng="'+location.longitude+'">'+
			                                                                      '<i class="fas fa-street-view"></i> Get Directions'+
			                                                                    '</a>'+
			                                                                '</div>';
			                                            }
			                          contentString += '</div>'+
			                                        '</div>'+
			                                    '</div>'+
			                                  '</div>'+
			                              '</div>';



		   		}else{

		   			if(location.image){
			            var image = this.settings.defaultUrl+'/'+location.image;
			            var explodeFilename = location.image.split('.');
	        			 	if (typeof explodeFilename[0]!=='undefined')
	        			 		var imageFileName = this.settings.defaultUrl+'/'+explodeFilename[0]+'.webp';

					}
			        else if(location.schoolImage){
			            var image = this.settings.defaultUrl+'/uploads/images/schools/'+location.schoolImage;
			            var explodeFilename = location.schoolImage.split('.');
	        			 	if (typeof explodeFilename[0]!=='undefined')
	        			 		var imageFileName = this.settings.defaultUrl+'/uploads/images/schools/'+explodeFilename[0]+'.webp';

			        }
			          else{
			            var image = this.settings.defaultUrl+'/img/noimage.jpg';
			            var imageFileName = this.settings.defaultUrl+'/img/noimage.webp';
			        }

				var locationLink = '/school/'+location.schoolSlug+'/location/'+location.id,
					loaderIcon = this.settings.defaultUrl+'/img/loader.svg',
					avg = (!location.reviewsAVG)? '4.8' : parseFloat(location.reviewsAVG);


					var contentString = '<div class="info-window-content">'+
				                            '<div class="info-window-box">'+
											'<a data-school="'+location.schoolsId+'" data-location="'+location.id+'" id="add-map-filter-'+location.id+'" href="'+locationLink+'" class="icon-btn tooltip-bt view-location-popup"  data-toggle="tooltip" data-placement="bottom" title="View School" >'+
				                            	'<div class="info-window-image-holder">';
			            contentString += '				<picture>';
														if(imageFileName){
						contentString += '				<source srcset="'+imageFileName+'" type="image/webp">';
														}
						contentString += '				<img class="lazyload info-window-image" alt="'+location.name+'" data-src="'+image+'" loading="lazy" width="80" height="45">';
						contentString += '				</picture>'+
				                            	'</div>'+
				                                '<div class="info-window-text">'+
				                                	'<div class="info-window-name">'+
				                                		'<label>'+location.schoolName+'</label>'+
				                                	'</div>'+
				                                	'<div class="info-window-address">'+
				                                    	'<mark><i class="fas fa-map-marker-alt"></i>'+location.displayAddress+'</mark>'+
				                                    '</div>'+
				                                    '<div class="contact-view">'+
				                                    	'<div class="info-window-contact">';
					    contentString += '				<div class="dsl-rating">';
														for(var i = 0;i < 5; i++){
															if(i == parseInt(avg)){
																if(avg - Number(avg).toFixed(1) >= 0.5 || avg - Math.floor(avg) == 0){
						contentString += '							<span class="fas fa-star"></span>';
																}
																else{
						contentString += '							<span class="fas fa-star-half-alt"></span>';
																}
															}else{
														   		if(i <= parseInt(avg)){
						contentString += '							<span class="fas fa-star"></span>';
														   		}
														   		else{
					    contentString += '                           <span class="far fa-star"></span>';
														   		}
															}
														}
						contentString += '				</div>'+
				                                    	// '<div class="info-window-cta">'+
				                                    	// 	'<a data-school="'+location.schoolsId+'" data-location="'+location.id+'" id="add-map-filter-'+location.id+'" href="'+locationLink+'" class="icon-btn tooltip-bt view-location-popup"  data-toggle="tooltip" data-placement="left" title="View School" ><i class="fas fa-street-view"></i></a>'+
				                                    	// '</div>'+
				                                    '</div>'+
				                                '</div>'+
				                            '</a>'+
				                            '</div>'+
				                        '</div>';


			    }


			    return contentString;

		   }
		   this.displayServiceArea = function(location){

		   		setTimeout(function () {
	            	shouldLoadNewLocations = true;
	            	loadNewLocations = true;

	            }, 1200);
		   		// var that = this;
		   		// if(location){
		   		// 	$.ajax({
	        	// 	  async: true,
			    //       method: "GET",
			    //       url: "/locations/service-areas/"+location.id,
			    //       success: function(data) {

			    //       		if(data.service_areas){
				//           		map.data.setStyle({
			    //                     strokeColor: '#E63946',
			    //                     strokeOpacity: 0.8,
			    //                     strokeWeight: 1,
			    //                     fillColor: '#E63946',
			    //                     fillOpacity: 0.2
			    //                 });
				// 	   			$.each(data.service_areas, function(i,k){
				// 	   				if(k){
			    //                         map.data.addGeoJson(
			    //                             k.json_shape
			    //                           );
			    //                         serviceAreas.push(k.id);
				// 	   				}

				// 	   			});
			    //       		}

			    //       		setTimeout(function () {
				//             	shouldLoadNewLocations = true;
				//             	loadNewLocations = true;

				//             }, 1200);
			          		


			    //       },
			    //       error: function(data) {
			    //             setTimeout(function () {
				//             	shouldLoadNewLocations = true;
				//             	loadNewLocations = true;

				//             }, 1000);
			    //       }
				//     });
                    
		   		// }
		   };

	       this.addMarker = function(position,location){

	       		if(!markers[location.id]){
	       			var that = this;

	       			if(location.currentOrderNo){
	       				var currentImage = that.settings.defaultUrl+'/uploads/images/marker-'+location.currentOrderNo+'.png';
	       				var currentImageHover = that.settings.defaultUrl+'/uploads/images/marker-'+location.currentOrderNo+'-hover.png';
	       			}else{
	       				var currentImage = iconimage;
	       				var currentImageHover = iconimageHover;

	       			}

	       			var contentString = that.infoWindowString(location);
	       			var marker = new google.maps.Marker({
				      position: position,
				      // label: location.schoolName,
				      label: '',
				      icon: currentImage,
				      draggable:false,
				      map: map,
				      optimized: false,
				      zIndex:location.id,
				      animation: null,
				    });


				    var infowindow = new google.maps.InfoWindow({
				      content: contentString,
				      maxWidth: 360
				    });
				    infoWindows.push(infowindow);

					marker.addListener('click', function() {
						shouldLoadNewLocations = false;
						loadNewLocations = false;

						marker.setIcon(currentImageHover);
						marker.setZIndex(99999);
						if($(that.settings.listElement).find('.dsl-info-holder[data-id="'+location.id+'"]').length)
							$(that.settings.listElement).find('.dsl-info-holder[data-id="'+location.id+'"] .ds-image img').attr('src',currentImageHover);
						
						$.when(that.closeInfoWindows(),that.closeServiceAreas()).then(function () {
							that.displayServiceArea(location);
					      	google.maps.event.addListener(infowindow,'closeclick',function(){
							   marker.setIcon(currentImage);
							   marker.setZIndex(location.id);
							   that.closeServiceAreas();
							   if($(that.settings.listElement).find('.dsl-info-holder[data-id="'+location.id+'"]').length)
									$(that.settings.listElement).find('.dsl-info-holder[data-id="'+location.id+'"] .ds-image img').attr('src',currentImage);

							});
					      	infowindow.open(map, marker);
						});
				    });

				    marker.addListener('mouseover', function() {
					    marker.setIcon(currentImageHover);
					    marker.setZIndex(99999);
					    if($(that.settings.listElement).find('.dsl-info-holder[data-id="'+location.id+'"]').length)
								$(that.settings.listElement).find('.dsl-info-holder[data-id="'+location.id+'"] .ds-image img').attr('src',currentImageHover);

					});
					marker.addListener('mouseout', function() {
					    marker.setIcon(currentImage);
					    marker.setZIndex(location.id);
					    if($(that.settings.listElement).find('.dsl-info-holder[data-id="'+location.id+'"]').length)
								$(that.settings.listElement).find('.dsl-info-holder[data-id="'+location.id+'"] .ds-image img').attr('src',currentImage);

					});


				    markers[location.id] = [];
				    if(!markers[location.id])
	       				markers[location.id].push(marker);
	       			else
	       				markers[location.id] = marker;
	       		}



	       };

	       this.createHelper = function(){


	           var total = Object.keys(this.settings.locations).length,
	           	   html = '<ul class="pagination pagination-circle pg-blue">',
	               // query = this.QueryString(), //an array of the query parameters
	               p = parseInt(this.settings.p), //the current page that we are on, we get it from the query parameters
	               nshow = parseInt(this.settings.n), // how many items are we showing per page
	               radius = Math.floor(this.settings.pager_length/2), //setup a radius that controls how many paginator controls are shown
	               pages = (total % nshow == 0)?Math.floor(total / nshow):Math.floor(total / nshow) + 1, // the total number of pages
	               lastI = parseInt((pages-2) * nshow + 1),
	               firstI = parseInt(nshow) + 1,
	               low = parseInt(p) - radius * nshow, //this is the low border of the pager controls
	               high =(parseInt(p) + parseInt(radius * nshow)); //high border


	                if (low<0) high = high + low * (-1);
	                if (high>(pages-1)*nshow) low = low - (high - ((pages-1) * nshow));

	                

	                if(p>=firstI || p > 0){
	                	if(p == 1)
	                    	html += '<li class="page-item prev disabled">'+this.createUrl({page:(p - nshow),caption:'<span class="fas fa-angle-left"></span>'})+'</li>';
	                	else
	                    	html += '<li class="page-item prev">'+this.createUrl({page:(p - nshow),caption:'<span class="fas fa-angle-left"></span>'})+'</li>';

	                }
	                else if(pages > 1)
	                    html += '<li class="page-item prev disabled"><label class="page-link"><span class="fas fa-angle-left"></span></label></li>';


	                for(var i=0;i<pages;i++){
	                    var iteration = i * nshow;

	                    if (p==iteration || p == iteration+1) {
	                        html += '<li class="page-item current active"><label class="page-link"><span>'+(i+1)+'</span></label></li>';
	                        continue;
	                    }
	                    if(i==(pages-1) && (pages>this.settings.pager_length)){
	                            if ((high<lastI))
	                            html += '<li class="page-item last">'+this.createUrl({page:(parseInt(lastI) + parseInt(nshow)),caption:'<span class="fas fa-angle-double-right"></span>'})+'</li>';
	                            else
	                            html += '<li class="page-item last">'+this.createUrl({page:(i * nshow + 1),caption:'<span class="fas fa-angle-double-right"></span>'})+'</li>';
	                        continue;
	                    }
	                    if(i==0 && (pages>this.settings.pager_length)){
	                        if (low>firstI)
	                            html += '<li class="page-item first">'+this.createUrl({page:'1',caption:'<span class="fas fas fa-angle-double-left"></span>'})+'</li>';
	                        else
	                            html += '<li class="page-item first">'+this.createUrl({page:(i * nshow + 1),caption:'<span class="fas fas fa-angle-double-left"></span>'})+'</li>';
	                        continue;
	                    }
	                    if ((iteration >= low) && (iteration <= high))
	                        html += '<li class="page-item ">'+this.createUrl({page:(i * nshow),caption:(i + 1)})+'</li>';


	                }
	                if (p<=lastI)
	                    html += '<li class="page-item next">'+this.createUrl({page:(parseInt(p) + parseInt(nshow)),caption:'<span class="fas fa-angle-right"></span>'})+'</li>';
	                else
	                	html += '<li class="page-item next disabled"><label class="page-link"><span class="fas fa-angle-right"></span></label></li>';

	                html += '</ul><div class="partial-overlay"></div>';

	                $(this.settings.paginationWrapper).empty().html(html);
	       },
	       this.createUrl = function(params){

			var that = this;
			var nshow = parseInt(that.settings.n), // how many items are we showing per page
				page = (params.page && params.page > 0) ? params.page : 1,
				caption = (params.caption && isNaN(params.caption)) ? params.caption : '<span>'+params.caption+'</span>',
				q = '',
				null_status = '';


	           return '<a data-page="'+page+'" href="'+this.settings.url.split('?')[0]+'?'+this.settings.page+'='+page +'&'+this.settings.nshow+'='+nshow+'&'+this.settings.name+'='+q+'&null='+null_status+'" class="page-link">'+caption+'</a>';
	       }

	       this.jSwitchCall = function(){

	       		$('.tooltip-bt').tooltip({ boundary: 'window' });

	       },

	       this.loadInsuranceScript = function(sync){
	       		var that = this;
				var script = document.createElement('script');
			        script.onload = function() {
			            cf_ads(that.settings.insuranceSubId, 'GET FREE QUOTE'); // parameters are id to fill (which is also the ab variable) and button text (CTA)
			            // this loads the ad slot when the script is ready on page load,
			            // but one could wrap cf_ads() call with an event handler for when practice test finished
			            // (if such an event exists)
			            // example below
			            document.addEventListener('practicetest.finished', function() {
			                cf_ads(that.settings.insuranceSubId, 'GET FREE QUOTE');
			            });
			            // this would reduce impressions and assumes the ad is part of the last step of the practice test

			            // Sample event handlers for our events 
			            document.getElementById(that.settings.insuranceSubId).addEventListener('clickfeed.finished', function() {

			                $('#locations-insurance-holder').addClass('auto-insurance-banner-loaded');

			                

			                // code whatever DOM manipulations you want that happen after the bidding is finished and the target div is filled
			                // example would be copying the button's href to a existing link
			                // another example could be hiding the ad initially until it is filled and then show it

			                var linkToRedirect = $('#'+that.settings.insuranceSubId).find('a').attr('href');

			                if(linkToRedirect){
			                	$('#insurance-banner-question').find('a#insurance-compare-link').attr('href',linkToRedirect);					                
									                
			                }else{
			                	//  no winner
			                	$('#locations-insurance-holder').removeClass('auto-insurance-banner-loaded');
			                }

			                $('#'+that.settings.insuranceSubId).find('button').html("Powered By").promise().done(function () {

			                	that.settings.insuranceBannerHtml = $(that.settings.listElement).find('#locations-insurance-holder').html()
			                });



			            });
			            // this will hide the ad wrapper should the ad fail to return a result (rare)
			            document.getElementById(that.settings.insuranceSubId).addEventListener('clickfeed.failed', function() {
			                $('#locations-insurance-holder').removeClass('auto-insurance-banner-loaded');
			                that.settings.insuranceBannerHtml = '';
			                // you could also inject a div displaying "No results" or whatever DOM manipulattions
			            });
			        };
	    	
			    script.src = that.settings.scriptSrc;
			    script.async = true;
			    document.getElementsByTagName('head')[0].appendChild(script);

	       },

	       this.checkInsuranceBannerHelper = function(){


	       		if($(this.settings.listElement).find('#locations-insurance-holder').length){	       			

	       			if(this.settings.insuranceBannerHtml.length > 5){
	       				$(this.settings.listElement).find('#locations-insurance-holder').empty().html(this.settings.insuranceBannerHtml).promise().done(function(){
	       					 $('#locations-insurance-holder').addClass('auto-insurance-banner-loaded');
	       				});
	       				
	       			}else{


	       				if(this.settings.searchData.type){
	       					if(this.settings.searchData.type == 'motorcycleLicence'){
	       						this.settings.insuranceSubId = 'dschool_moto_v1';
	       						this.settings.scriptSrc = "https://d3iv2l0es6sf8g.cloudfront.net/1047/SDC/gl/moto/cfad_s.js";
	       					}

	       					if(this.settings.searchData.type == 'commercialLicence'){
	       						this.settings.insuranceSubId = 'dschool_commercial_v1';
	       						this.settings.scriptSrc = "https://d3iv2l0es6sf8g.cloudfront.net/1047/SDC/gl/biz/cfad_s.js";
	       					}
	       				}

			       		var insuranceHtml = '';

			       		insuranceHtml +=	'<div class="dsl-info-wraper dsl-info-wraper-full">';
			       		insuranceHtml +=	'<div id="insurance-banner-question" class="insurance-banner-holder single_ad">';
						insuranceHtml +=	'	<div class="insurance-text-top">';
						insuranceHtml +=	'		<p>Before selecting a driving school, please answer the question bellow regarding the insurance status of the individual enrolling in driving school.</p>';
						insuranceHtml +=	'	</div>';
						insuranceHtml +=	'	<div class="insurance-banner">';
						insuranceHtml +=	'		<div class="insurance-banner-text">';		
						insuranceHtml +=	'			<div class="question-row-insurance">';
						insuranceHtml +=	'				<div class="question-insurance">';
						insuranceHtml +=	'					<h3>Will the new driver be covered undered an existing auto insurance policy</h3>';
						insuranceHtml +=	'				</div>';
						insuranceHtml +=	'				<div class="anwers-insurance-holder">';
						insuranceHtml +=	'					<div class="answer-pick-holder">';
						insuranceHtml +=	'						<div class="form-check">';
						insuranceHtml +=	'						  <input class="form-check-input" type="radio" name="insurance-check" value="yes" id="insurance-check-yes">';
						insuranceHtml +=	'						  <label class="form-check-label" for="insurance-check-yes">';
						insuranceHtml +=	'						    <span>Yes, the new driver will be covered</span>';
						insuranceHtml +=	'						    <mark id="insurance-yes">Great, you\'re all set. <a href="javascript:;" id="insurance-compare-link" target="_blank"> Click here</a> if you want to compare rates.</span>';
						insuranceHtml +=	'						  </label>';
						insuranceHtml +=	'						</div>';
						insuranceHtml +=	'						<div class="form-check">';
						insuranceHtml +=	'						  <input class="form-check-input" type="radio" name="insurance-check" value="no" id="insurance-check-no">';
						insuranceHtml +=	'						  <label class="form-check-label" for="insurance-check-no">';
						insuranceHtml +=	'						    <span>No, the new driver needs auto insurance and wants to compare options</span>';
						insuranceHtml +=	'						  </label>';
						insuranceHtml +=	'						</div>';
						insuranceHtml +=	'					</div>';
						insuranceHtml +=	'				</div>';
						insuranceHtml +=	'			</div>';
						insuranceHtml +=	'		</div>';
						insuranceHtml +=	'		<div class="insurance-banner-cta">';
						insuranceHtml +=	'			<div id="'+this.settings.insuranceSubId+'" class="dwt_single"></div>';
						insuranceHtml +=	'		</div>';
						insuranceHtml +=	'	</div>';
						insuranceHtml +=	'</div>';
						insuranceHtml +=	'</div>';


						$(this.settings.listElement).find('#locations-insurance-holder').empty().html(insuranceHtml);
						this.loadInsuranceScript(true);					


	       			}



				}
	       },


	       this.buildLocationView = function(){
	       		var that = this;
	        	this.pagedData = Object.entries(that.settings.locations).slice(that.settings.p-1,that.settings.n+that.settings.p-1).map(entry => entry[1]);
	        	var locationHtml = '<div class="school-founded-results">';

                if(this.pagedData && this.pagedData.length > 0){
                   locationHtml +=	'<div class="defined-results-found">';
                   if(that.settings.searchData.searchNear && that.settings.searchData.searchNear.length > 1)
                   		locationHtml +=	'<label><span class="">We found:</span><mark>'+that.settings.locations.length +' schools '+that.settings.searchData.searchNear+' </mark></label>';
                   else
                   		locationHtml +=	'<label><span class="">We found:</span><mark>'+that.settings.locations.length +' schools </mark></label>';
                   
                   locationHtml +=	'</div>';
                }

               	

                locationHtml +=	'<div class="defined-results-locations">';
                locationHtml +=	'<div class="defined-width">';



	        	if(this.pagedData && this.pagedData.length > 0){
	        		if(this.settings.notClickedInsuranceBanner)
                		locationHtml +=	'<div id="locations-insurance-holder" ></div>';

	        		$.each(this.pagedData,function(i,loc){


	        			if(loc.image){
	        			 	var image = that.settings.defaultUrl+'/'+loc.image;
	        			 	var explodeFilename = loc.image.split('.');
	        			 	if (typeof explodeFilename[0]!=='undefined')
	        			 		var imageFileName = that.settings.defaultUrl+'/'+explodeFilename[0]+'.webp';
	        			}
	        			else if(loc.schoolImage){
	        			 	var image = that.settings.defaultUrl+'/uploads/images/schools/'+loc.schoolImage;
	        			 	var explodeFilename = loc.schoolImage.split('.');
	        			 	if (typeof explodeFilename[0]!=='undefined')
	        			 		var imageFileName = that.settings.defaultUrl+'/uploads/images/schools/'+explodeFilename[0]+'.webp';

	        			}else{
	        			 	var image = that.settings.defaultUrl+'/img/noimage.jpg';
	        			 	var imageFileName = that.settings.defaultUrl+'/img/noimage.webp';

	        			}


	        			var avg = (!loc.reviewsAVG)? '4.8' : parseFloat(loc.reviewsAVG),
	        				locationLink = '/school/'+loc.schoolSlug+'/location/'+loc.id,
	        				loaderIcon = that.settings.defaultUrl+'/img/loader.svg',
	        				carLicence = (loc.carLicence)? '<div class="category-icon"><span class="ds-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 18 18"><g fill="#fff"><path d="M14.578125 9.179688c.648437 0 1.171875.523437 1.171875 1.171874.019531.574219-.449219 1.132813-1.117188 1.132813-.628906 0-1.152343-.503906-1.152343-1.171875-.015625-.664062.523437-1.132812 1.097656-1.132812zm0 0M4.140625 9.179688c.628906 0 1.132813.484374 1.132813 1.152343 0 .648438-.503907 1.152344-1.132813 1.152344-.628906 0-1.117187-.488281-1.132813-1.152344.015626-.648437.503907-1.152343 1.132813-1.152343zm0 0"/><path d="M.953125 9.738281c-.035156.054688-.035156.109375 0 .160157.054687.109374.089844.199218.125.308593.019531.015625.019531.054688.039063.070313.054687.035156.070312.109375.089843.164062.015625.015625.015625.035156.035157.050782.269531.199218.59375.199218.917968.273437.160156.035156.304688.035156.46875.050781.035156 0 .054688-.195312.035156-.285156 0-.054688.019532-.089844.019532-.144531v-.035157c.015625-.828124.644531-1.476562 1.4375-1.476562.578125 0 1.0625.324219 1.296875.808594v.019531c.019531.015625.019531.054687.035156.070313.164063.398437.144531.792968.109375.828124-.035156.144532-.074219.304688-.089844.414063-.019531.074219.035156.125.105469.125.199219-.015625.597656-.050781 1.011719-.089844 2.210937 0 4.40625-.015625 6.640625-.015625.035156-.054687.015625-.039062.054687-.089844-.074218-.144531-.128906-.433593-.128906-.59375.019531-.828124.648438-1.476562 1.441406-1.476562.792969 0 1.441406.628906 1.441406 1.457031 0 .199219-.035156.359375-.074218.449219-.015625.054688.019531.089844.054687.089844.164063 0 .34375 0 .503907-.054688.074218-.015625.144531-.015625.214843-.035156.089844-.015625.109375-.054688.109375-.144531v-.035157c.074219-.160156.089844-.324218.109375-.484374 0-.039063 0-.074219.015625-.109376.089844-.054687.089844-.054687.089844-.144531 0-.089843.019531-.160156.019531-.25 0-.074219-.035156-.128906-.089843-.164062-.070313-.035157-.164063-.070313-.234376-.105469v-.039062-.234376c.019532-.25-.109374-.394531-.304687-.503906-.109375-.050781-.21875-.089844-.324219-.125-.234375-.054687-1.027344-.269531-1.207031-.304687-.289063-.054688-.59375-.089844-.898437-.125-.324219-.039063-.632813-.054688-.957032-.089844-.125-.019531-.25-.019531-.394531 0-.089844 0-.160156-.019531-.234375-.054687-.613281-.359376-2.265625-1.117188-2.449219-1.207032-.304687-.144531-.644531-.199218-.96875-.253906-.21875-.035156-.433593-.035156-.648437-.035156-.738282 0-1.476563 0-2.214844.074218-.304688.035157-.613281.070313-.917969.144532-.324219.070312-.648437.230468-.953125.339844-.414062.164062-.8125.359374-1.226562.539062-.214844.144531-.738282.269531-1.257813.269531h-.414062c-.035157 0-.074219 0-.109375.019531-.035156.019532-.070313.035157-.054688.089844.074219.289063.039063.578125-.015625.863282-.019531.109374-.019531.21875-.019531.34375v.054687c-.035156.015625-.089844.015625-.125.035156-.109375.035157-.164062.144531-.144531.25.019531.089844.035156.179688.054687.269531 0 0 0 .039063-.019531.074219zM7.34375 6.660156C7.6875 6.625 8.191406 6.625 8.566406 6.640625c.363282.019531.703125.074219 1.046875.179687.304688.109376 1.527344.757813 1.527344.757813.039063.019531.054687.035156.089844.054687h-.050781c-.019532 0-.039063.015626-.074219.035157-.035157-.019531-.054688-.019531-.089844-.019531-.019531 0-.179687-.070313-.214844.054687 0 .019531-.035156.109375-.035156.164063 0 .125.089844.195312.089844.195312-.019531.039062-.039063.074219-.054688.109375-.074219 0-1.945312-.054687-3.1875-.070313l-.359375-1.261718c0-.089844.035156-.179688.089844-.179688zM4.121094 7.6875c0-.109375.144531-.21875.179687-.234375.089844-.074219.523438-.269531 1.097657-.503906C5.867188 6.75 6.496094 6.75 6.730469 6.714844c.054687 0 .089843.035156.089843.070312l.109376 1.261719c-.25 0-2.484376-.054687-2.539063-.054687-.070313 0-.25-.089844-.269531-.304688zm0 0"/></g></svg></span></div>' : '',
	        				commercialLicence = (loc.commercialLicence)? '<div class="category-icon"><span class="ds-icon"><svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.8068 15.975c1.05436 0 1.90909-.8453 1.90909-1.8879 0-1.0426-.85473-1.8879-1.90909-1.8879-1.05437 0-1.90909.8453-1.90909 1.8879 0 1.0426.85472 1.8879 1.90909 1.8879zM15.2614 15.975c1.0544 0 1.9091-.8453 1.9091-1.8879 0-1.0426-.8547-1.8879-1.9091-1.8879s-1.9091.8453-1.9091 1.8879c0 1.0426.8547 1.8879 1.9091 1.8879z" fill="#fff"/><path d="M19.0795 9.49243c0-.34611-.3181-.44051-.5727-.44051h-1.2409l-1.4-2.51717h-3.15v5.66365c.3333-.4429.7786-.7912 1.2912-1.0101.5125-.2188 1.0742-.3005 1.6288-.2367.5545.0637 1.0823.2707 1.5304.6.4481.3293.8007.7694 1.0223 1.2761h.8909V9.49243zm0 3.96457h-.7c.0858.4152.0858.8433 0 1.2586h.7c.1688 0 .3307-.0663.45-.1844.1194-.118.1864-.278.1864-.4449s-.067-.327-.1864-.445c-.1193-.118-.2812-.1843-.45-.1843zM.625 12.8277h.254545c.248955-.5584.656725-1.0331 1.173635-1.3663.51691-.3333 1.12066-.5107 1.73773-.5107s1.22082.1774 1.73773.5107c.51691.3332.92467.8079 1.17363 1.3663h4.74093V4.01758H.625v8.81012zm6.36364 1.2586c0 .2113-.02132.4221-.06364.6293h4.5182V13.457H6.925c.04232.2071.06364.4179.06364.6293z" fill="#fff"/></svg></span></div>' : '',
	        				motorcycleLicence = (loc.motorcycleLicence)? '<div class="category-icon"><span class="ds-icon"><svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5625 9.88882c-.2623.00103-.5234.03488-.7772.10074l-.3969-.80347c.9715-.37261 2.0073-.5538 3.0491-.53338.1658 0 .3247-.06512.442-.18102.1172-.11591.183-.27312.183-.43703 0-.16392-.0658-.32113-.183-.43704-.1173-.1159-.2762-.18102-.442-.18102-1.2318-.02391-2.4556.20167-3.5959.66286-.8869-1.79236-1.6835-3.39621-1.7628-3.52786-.1663-.27349-.5125-.84333-1.1875-.84333H9.68751c-.16576 0-.32473.06511-.44194.18102-.11721.11591-.18306.27311-.18306.43703 0 .16392.06585.32113.18306.43703.11721.11591.27618.18103.44194.18103h2.15219c.0605.07408.115.15282.1628.23548.0313.055.1491.28801.3284.64587-1.9412 1.43636-3.58776 2.82698-4.81683 2.82698h-.98281C4.68282 7.20708 2.1897 6.79854.937511 6.79854c-.165761 0-.324732.06512-.441942.18103-.11721.11591-.183058.27311-.183058.43703 0 .16392.065848.32112.183058.43703.11721.11591.276181.18103.441942.18103.051875 0 4.324059.09672 5.979999 2.90144l-.87156.3452c-.43047-.6516-1.09049-1.1216-1.85183-1.31891-.76135-.19726-1.56966-.10763-2.26792.25151-.69825.3591-1.236593.9621-1.51044 1.6917-.273846.7297-.263645 1.534.028622 2.2566.292267.7227.845728 1.3121 1.552878 1.6538.70714.3416 1.51747.4112 2.27358.1951.7561-.2161 1.40399-.7024 1.81779-1.3644.41381-.6621.564-1.4526.42138-2.218l.88188-.3489c.08126.3091.13356.6249.15625.9435.01131.1561.08208.3021.19802.4086.11594.1065.26842.1656.42666.1653h3.38968c.1523-.0002.2992-.0552.4133-.1549.1141-.0997.1875-.2372.2064-.3866.2343-1.3258.9916-2.5053 2.1053-3.27906.125.24996.2481.50276.3725.75556-.5848.4467-.9902 1.0841-1.144 1.7988-.1539.7147-.0462 1.4602.3039 2.1036.3501.6435.9199 1.1432 1.6077 1.41.6879.2668 1.4492.2835 2.1484.0471.6991-.2365 1.2907-.7107 1.6692-1.3382.3786-.6275.5196-1.3675.398-2.0882-.1217-.7207-.4982-1.3753-1.0624-1.8471-.5641-.4719-1.2794-.73035-2.0183-.72938zM5.31251 12.9791c.00178.4361-.15131.8589-.43258 1.1947-.28126.3359-.67284.5634-1.1064.6429-.43357.0795-.88161.006-1.26594-.2078-.38433-.2138-.68056-.5542-.83701-.9619-.15644-.4077-.16316-.8568-.01899-1.2689.14417-.4121.43008-.7611.80784-.986.37777-.2249.8234-.3116 1.25916-.2448.43576.0668.83398.2828 1.12517.6102l-1.63875.649c-.07766.0291-.14867.0732-.20889.1297-.06022.0566-.10843.1244-.14184.1996-.0334.0752-.05131.1562-.05269.2383-.00138.0822.0138.1637.04466.24.03086.0762.07677.1456.13505.2041.05829.0585.12778.1049.20442.1366.07663.0316.15887.0478.24192.0477.08304-.0002.16523-.0167.24175-.0486l1.63875-.649c.00218.0248.00437.0495.00437.0742zm11.24999 1.8542c-.3695.0002-.7309-.1076-1.0386-.31-.3077-.2023-.5481-.4902-.6908-.8273-.1427-.3371-.1814-.7084-.1112-1.0672.0702-.3587.2461-.689.5056-.9492.2697.547.5313 1.0798.7731 1.5705.0359.0731.0861.1384.1475.1923.0614.0539.133.0953.2106.1218.0777.0266.1598.0378.2418.0329.082-.0048.1622-.0256.2361-.0611.0738-.0355.1399-.0851.1944-.1459.0545-.0607.0964-.1315.1232-.2083.0269-.0767.0382-.158.0333-.239-.0049-.0811-.026-.1604-.0619-.2335-.1853-.3773-.4575-.9302-.7737-1.5717.254-.0295.5115-.0073.7565.0653.2451.0725.4725.1939.6683.3566.1959.1628.356.3634.4705.5896.1145.2262.181.4731.1954.7257.0144.2525-.0236.5053-.1117.7428-.0881.2375-.2244.4546-.4005.6381-.1761.1834-.3883.3293-.6235.4286-.2353.0994-.4886.1501-.7444.149z" fill="#fff"/></svg></span></div>' : '';

	        			var todayWork = (loc.hours)? loc.hours.find(obj => { return obj.day === that.settings.today }) : false;

		        		locationHtml +=	'  <div class="dsl-info-wraper">';
						locationHtml += '		<div class="dsl-info-holder no-margin-on-mobile" data-id="'+loc.id+'">';
						locationHtml += '			<div class="dsl-photo-show">';
						locationHtml += '				<a class="school-link-view view-location-popup" data-location="'+loc.id+'" data-school="'+loc.schoolsId+'" href="'+locationLink+'" title="'+loc.schoolName+'">';
						locationHtml += '				<picture>';
														if(imageFileName){
						locationHtml += '				<source srcset="'+imageFileName+'" type="image/webp">';
														}
						locationHtml += '				<img class="lazyload" alt="'+loc.name+'" data-src="'+image+'" loading="lazy" width="300" height="169">';
						locationHtml += '				</picture>';
						locationHtml += '				</a>';
						locationHtml += '				<div class="dsl-category">';
						locationHtml += '					<a class="school-link-view view-location-popup" data-location="'+loc.id+'" data-school="'+loc.schoolsId+'" href="'+that.settings.defaultUrl+'/school/'+loc.schoolSlug+'" title="'+loc.schoolName+'">';
						locationHtml += 						carLicence+motorcycleLicence+commercialLicence
						locationHtml += '					</a>';
						locationHtml += '				</div>';
						locationHtml += '			</div>';
						locationHtml += '			<div class="dsl-basic-info">';
						locationHtml += '				<div class="dsl-name">';
						locationHtml += '					<div class="name"><a class="school-link-view view-location-popup" data-location="'+loc.id+'" data-school="'+loc.schoolsId+'" href="'+locationLink+'" title="'+loc.schoolName+'">'+loc.schoolName+'</a></div>';
						locationHtml += '					<div class="name"><a class="school-link-view view-location-popup" data-location="'+loc.id+'" data-school="'+loc.schoolsId+'" href="'+locationLink+'" title="'+loc.schoolName+'"><span class="ds-icon ds-image"><img src="'+that.settings.defaultUrl+'/uploads/images/marker-'+loc.currentOrderNo+'.png" title="'+loc.schoolName+'" /></span></a></div>';
						locationHtml += '				</div>';
				        locationHtml += '				<div class="dsl-work-time dropdown">';
															if(loc.hours && loc.hours.length > 0){
						locationHtml += '					<div class="dropdown-toggle" id="dropdownHours'+loc.id+'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">';
						locationHtml += '						<span class="far fa-clock"></span>';
						locationHtml += '						<span class="example-time">';
																	if(todayWork){
																		if(todayWork.startAt && that.settings.hours[todayWork.startAt])
																			locationHtml += that.settings.hours[todayWork.startAt];
																		else
																			locationHtml += 'Not Set';
						locationHtml += ' - ';
																		if(todayWork.closeAt && that.settings.hours[todayWork.closeAt])
																			locationHtml += that.settings.hours[todayWork.closeAt];
																		else
																			locationHtml += 'Not Set';

																	}else{
						locationHtml += '								Not Working Today';
																	}
						locationHtml += '						</span>';
						locationHtml += '						<span class="fas fa-angle-down"></span>';
						locationHtml += '					</div>';
						locationHtml += '					<div class="show-work-time dropdown-menu" aria-labelledby="dropdownHours'+loc.id+'">';
						locationHtml += '						<ul>';
																	$.each(loc.hours, function(j,hour){
																		var currentDay = (todayWork && todayWork.id == hour.id)? 'current' : '';
						locationHtml += '								<li class="'+currentDay+'-day">';
						locationHtml += '									<span class="current-day-circle"></span>';
						locationHtml += '									<div class="working-days '+currentDay+'">'+that.settings.daysShort[hour.day]+'</div>';
						locationHtml += '									<div class="working-hours">';
						locationHtml += '										<span class="ds-icon"><i class="far fa-clock"></i></span>';
																				if(hour.startAt && that.settings.hours[hour.startAt])
																					locationHtml += that.settings.hours[hour.startAt];
																				else
																					locationHtml += 'closed';
						locationHtml += '  /  ';
																				if(hour.closeAt && that.settings.hours[hour.closeAt])
																					locationHtml += that.settings.hours[hour.closeAt];
																				else
																					locationHtml += 'closed';

						locationHtml += '									</div>';
						locationHtml += '								</li>';
																	});
						locationHtml += '						</ul>';
						locationHtml += '					</div>';
															}
						locationHtml += '				</div>';
                        locationHtml += '				<div class="rating-link-holder">';
                        locationHtml += '					<div class="dsl-rating">';
                        for(var i = 0;i < 5; i++){
                            if(i == parseInt(avg)){
                                if(avg - Number(avg).toFixed(1) >= 0.5 || avg - Math.floor(avg) == 0){
                                    locationHtml += '								<span class="fas fa-star"></span>';
                                }
                                else{
                                    // locationHtml += '								<span class="fas fa-star-half-alt"></span>';
                                    locationHtml += '								<span class="fas fa-star"></span>';
                                }
                            }else{
                                if(i <= parseInt(avg)){
                                    locationHtml += '								<span class="fas fa-star"></span>';
                                }
                                else{
                                    locationHtml += ' 		                        <span class="far fa-star"></span>';
                                }
                            }
                        }
                        locationHtml += '					</div>';
                        // locationHtml += '					<div class="list-window-cta">';
                        //    locationHtml += '						<a data-school="'+loc.schoolsId+'" data-location="'+loc.id+'" id="add-list-filter-'+loc.id+'" href="'+locationLink+'" class="icon-btn tooltip-bt view-location-popup" data-toggle="tooltip" data-placement="left" title="View School" ><i class="fas fa-street-view"></i></a>';
                        //    locationHtml += '					</div>';
                        locationHtml += '				</div>';
						locationHtml += '			</div>';
						locationHtml += '		</div>';
						locationHtml += '	</div>';

	        		});

	        	}else{

	        		locationHtml +=	'  <div class="dsl-info-wraper dsl-info-wraper-full">';
	        		locationHtml +=	'  		<div class="dsl-info-holder-empty no-margin-on-mobile">';
	        		locationHtml +=	'  			<div class="dsl-info-holder-title">';
	        		locationHtml +=	'  				<p>Could not find Driving Schools near map selected Location</p>';
	        		locationHtml +=	'  				<p>Please zoom map near some bigger city</p>';
	        		locationHtml +=	'  			</div>';
	        		locationHtml +=	'  		</div>';
	        		locationHtml +=	'  </div>';




	        	}
	        	// locationHtml += '<div class="partial-overlay"><img class="overlay-image" src="'+that.settings.defaultUrl+'/img/loader.svg" /></div></div></div></div>';
	        	locationHtml += '<div class="partial-overlay"></div></div></div></div>';
	        	$(this.settings.listElement).empty().html(locationHtml);

	        	that.createHelper();
	        	that.checkInsuranceBannerHelper();
	        	that.jSwitchCall();


	       };

	       return this.initialize();

	    };


	});
})($);
